<app-page-body>
  <!-- header -->
  <app-page-header
    [title]="title"
    [isForm]="false"
    [showDefaultBtns]="false"
    [loading]="false"
  >
  </app-page-header>

  <!-- content -->
  <div class="app-page-content">
    <ng-container custom-content>
        <lib-menus></lib-menus>
    </ng-container>
  </div>
</app-page-body>
